export default __webpack_public_path__ + "static/media/accessory-smooth-griddle.e0ceb310.png";